import client from './client';

// Beim CI-Build eingebrannt (Git-Commit); lokal "dev".
export const FRONTEND_VERSION = process.env.REACT_APP_VERSION || 'dev';

export interface BackendVersion {
  version: string;
  builtAt: string | null;
}

export async function fetchBackendVersion(): Promise<BackendVersion> {
  const { data } = await client.get<BackendVersion>('/api/version');
  return data;
}
